import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { Inset } from 'syf-component-library/ui/spacing';
import { Small } from 'syf-component-library/ui/typography';
import colors from '../../../../../const/colors';
export const NoteContainer = styled(Inset) `
  background-color: ${colors.lighterGray};
  font-size: 14px;
  @media ${query.lessThanSmall} {
    border-radius: 5px;
  }
`;
export const DisclaimerText = styled(Small) `
  letter-spacing: 0;
  line-height: 20px;
`;
export const DisclaimerContainer = styled.div `
  @media ${query.lessThanSmall} {
    margin: 0 auto;
    width: 90%;
    border-radius: 5px;
  }
`;
